import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Container, Form, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import * as actions from '../actions/Jurisdiction';
import { getCounties, getCities } from '../actions/StaticData';
import States from '../components/common/States';
import Counties from '../components/common/Counties';
import Cities from '../components/common/Cities';
import Breadcrumb from '../components/AdminBreadcrumb';

class Jurisdiction extends React.Component {

    handleJurisdictionNameChange = (e) => 
        this.props.actions.updateJurisdiction('name', e.target.value);

    handleJurisdictionStateChange = (stateId ) => {
        this.props.actions.updateJurisdiction('stateId', stateId)
        this.props.actions.getCounties(stateId);
    }

    handleJurisdictionCountyChange = (countyId) => {
        this.props.actions.updateJurisdiction('countyId', countyId);
        this.props.actions.getCities(countyId)
    }
        
    handleJurisdictionCityChange = (cityId) =>
        this.props.actions.updateJurisdiction('cityId', cityId);

    handleSave = () => {
            this.props.actions.saveJurisdiction(this.props.jurisdiction);
            this.props.history.push('/jurisdictions');
    }

    render() {
        const { name, stateId, countyId, cityId } = this.props.jurisdiction;

        return (
            <Container>
                <div style={{ paddingBottom: '10px' }}>
                    <Breadcrumb history={this.props.history} />
                </div>
                <Form>
                    <Row>
                        <Col>
                            <States
                                onChange={this.handleJurisdictionStateChange}
                                value={stateId}
                                states={this.props.states}
                            />
                        </Col>
                        <Col>
                            <Counties
                                onChange={this.handleJurisdictionCountyChange}
                                value={countyId}
                                counties={this.props.counties}
                            />
                        </Col>
                        <Col>
                            <Cities
                                onChange={this.handleJurisdictionCityChange}
                                value={cityId}
                                cities={this.props.cities}
                            />
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Name:</Label>
                                <Input
                                    type='text'
                                    value={name || ''}
                                    onChange={this.handleJurisdictionNameChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <hr />
                            <Button type="submit" className={'float-right'} disabled={!stateId} onClick={this.handleSave}>Save</Button>
                        </Col>
                    </Row>
                </Form >
            </Container >
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        jurisdiction: state.Jurisdiction.toJS(),
        states: state.StaticData.get('states').toJS(),
        counties: state.StaticData.get('counties').toJS(),
        cities: state.StaticData.get('cities').toJS()
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions, getCounties, getCities }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Jurisdiction);